import axios from 'axios';
import authHeader from './authHeader';

const API_URL = '/api/sites/';

// Fetch all sites (expects array of sites with site_id, site_name, site_code, address, phone_number, latitude, longitude)
const getSites = async () => {
  const response = await axios.get(API_URL, { headers: authHeader() });
  return response.data;
};

// Create a new site. siteData must include site_name and site_code. Optional: address, phone_number, latitude, longitude.
const createSite = async (siteData) => {
  const response = await axios.post(API_URL, siteData, { headers: authHeader() });
  return response.data;
};

// Update existing site (admin only). siteData may include site_name, site_code, address, phone_number, latitude, longitude.
const updateSite = async (id, siteData) => {
  const response = await axios.put(API_URL + id, siteData, { headers: authHeader() });
  return response.data;
};

const siteService = {
  getSites,
  createSite,
  updateSite,
};

export default siteService;
